import "./polyfill/number-is-nan";

import "./modules/old";
import "bootstrap-sass";
import "jquery-match-height";

// import "./modules/webfont";
// import "./modules/view-more";
import "./modules/page-top";
// import "./modules/jqueryvalidation";
// import "./modules/menu-trigger";
// import "./modules/bs.tab";
import "./modules/js-header";
// import "./modules/js-footer";
// import "./modules/waypoints";
// import "./modules/dropdown-hover";
import "./modules/swiper-fv";
import "./modules/aos";
import "./modules/jquery-match-height";
import "./modules/popover";
import "./modules/luxy";
import "./modules/text-toggle-qa";
import "./modules/accordion";
